module.exports = {
    api_key: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
}